module.exports = __webpack_public_path__ + "img/middle-discharging-end.c6b1c036.png";